const LEAST_ERRONEOUS_STATUS = 400;

export const isImageNotFound = (url?: string) =>
  url
    ? fetch(url, { method: 'HEAD' })
        .then(response => response.status >= LEAST_ERRONEOUS_STATUS)
        .catch(() => true)
    : true;
